import { resourcesRoot } from "from-start/scene/resources";
export function toPath(fileName) {
    return `${resourcesRoot}/5-heart/${fileName}`;
}
//# sourceMappingURL=common.js.map